import { computed } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { getRecognitionBudgets } from '@/queries/recognition';
import { BUDGET_KINDS } from '@/pages/recognition/utils/budgets';

export function useBudgetPots(enabled = () => true) {
  const { data, isLoading } = useQuery({
    ...getRecognitionBudgets({ includeInactive: false }),
    enabled,
  });

  const pots = computed(() =>
    (data.value || []).filter(budget => budget.kind === BUDGET_KINDS.POT && budget.is_active),
  );

  return { pots, isLoading };
}
